import React from "react";

const REASONS = [
  {
    icon: "fa-medal",
    title: "65+ Years Strong",
    body: "South Florida's longest-standing termite and pest experts. Still family-driven since 1959.",
  },
  {
    icon: "fa-user-shield",
    title: "Licensed & Insured",
    body: "Every technician is certified, background-checked and fully insured before they step on your property.",
  },
  {
    icon: "fa-leaf",
    title: "Pet & Family Safe",
    body: "Targeted products and application methods that protect the people (and pets) living there.",
  },
  {
    icon: "fa-calendar-check",
    title: "On-Time, Every Time",
    body: "Two-hour appointment windows and friendly techs that call ahead. We respect your schedule.",
  },
  {
    icon: "fa-phone-volume",
    title: "Real People Answer",
    body: "No phone trees. Call 1-800-DEAD BUG and talk to a real South Florida team member.",
  },
  {
    icon: "fa-shield-halved",
    title: "Guaranteed Service",
    body: "If pests come back between scheduled visits, we come back free. It's that simple.",
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why" data-testid="why-section" className="relative bg-[color:var(--dbe-sand)] py-16 sm:py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #0B0B0E 0, #0B0B0E 1px, transparent 1px, transparent 18px)",
        }}
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-6 relative">
        <div className="max-w-2xl">
          <p className="text-[color:var(--dbe-red)] text-xs tracking-[0.35em] uppercase font-bold">Why Dead Bug Edwards</p>
          <h2 className="mt-3 sm:mt-4 text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.02] font-bebas">
            Built on reputation.<br /><span className="text-[color:var(--dbe-red)]">Backed by results.</span>
          </h2>
        </div>

        <div className="mt-10 sm:mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {REASONS.map((r) => (
            <div
              key={r.title}
              data-testid={`why-card-${r.title.toLowerCase().replace(/\s/g, "-")}`}
              className="bg-white rounded-2xl p-6 sm:p-7 border border-black/5 hover:-translate-y-1 transition-all duration-300 shadow-[0_20px_50px_-30px_rgba(0,0,0,0.3)]"
            >
              <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-xl bg-[color:var(--dbe-red)]/10 text-[color:var(--dbe-red)] flex items-center justify-center">
                <i className={`fa-solid ${r.icon} text-lg sm:text-xl`} />
              </div>
              <h3 className="mt-4 sm:mt-5 font-bebas text-xl sm:text-2xl tracking-wide">{r.title}</h3>
              <p className="mt-2 text-sm sm:text-base text-neutral-600 leading-relaxed">{r.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
